//bibliotecas
import React from 'react';
import { Link } from "react-scroll";

// CSS
import './App.css';


// componentes
import Calculadora from "./Calculadora/calculadora";
import CalculadoraParalelo from './Calculadora/calculadoraparalelo';
import CalculadoraLed from './Calculadora/calculadoraled';
import Content from './Content/content';
import Contentled from './Content/contentled';
import Botao from './Content/botao';
import Cores from './Calculadora/coresresistor';

//imagens
import RBotao from './ResistorIcone.png';
import LBotao from './LedBotao.png';
import BBotao from './Bandas.png';

//// <a href="https://pt.wikipedia.org/w/index.php?title=Resist%C3%AAncia_el%C3%A9trica&oldid=58348308" className="link">
//// <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Resistor_symbol_America.svg/1280px-Resistor_symbol_America.svg.png" alt="resistor" className="imgResistor"/>
//// </a>
function App() {
  return (
    <div id="particles-container">
      <header className="header">
        <img src="Resistor.png" alt="logo" className="logo" />
        <Link
          to="A"
          spy={true}
          offset={-100}
          smooth={true}
          activeClass="active"
          duration={500}
          className="link">
          <img src={RBotao} alt="resistor" className="imgResistor" />
        </Link>
        <Link
          to="B"
          spy={true}
          smooth={true}
          offset={100}
          activeClass="active"
          duration={500}
          className="link">
          <img src={LBotao} alt="imgLed" className="imgLed" />
        </Link>
        <Link
          to="C"
          spy={true}
          smooth={true}
          offset={140}
          activeClass="active"
          duration={500}
          className="link"
        >
          <img src={BBotao} alt="res" className="imgBandas" />
        </Link>
        <Botao />
      </header>
      <div className="App">
        <h1 id="A" className='title'> Calculadora de Resistência Equivalente </h1>
        <section className="container row">
          <div className="linha">
            <Calculadora />
          </div>
          <div className="linha">
            <CalculadoraParalelo />
          </div>
        </section>
        <div className="Paragrafo">
          <Content />
        </div>
        <p className='Referencia'>
          RESISTÊNCIA ELÉTRICA. In: WIKIPÉDIA, a enciclopédia livre. Flórida: Wikimedia Foundation, 2020. Disponível em:
          <a href="https://pt.wikipedia.org/w/index.php?title=Resist%C3%AAncia_el%C3%A9trica&oldid=58348308">Wikipedia</a>.
          Acesso em: 14 ago. 2020. <a href="https://creativecommons.org/licenses/by-sa/2.5/br/"> CreativeCommons</a>, não foi sujeito a alterações.
        </p>
        <h1 id="B" className='title2'> Resistência Ideal para Leds </h1>
        <div className="column">
          <CalculadoraLed />
        </div>
        <div className="Paragrafo">
          <Contentled />
        </div>
        <p className='Referencia'>
          DIODO EMISSOR DE LUZ. In: WIKIPÉDIA, a enciclopédia livre. Flórida: Wikimedia Foundation, 2020. Disponível em:
          <a href="https://pt.wikipedia.org/wiki/Diodo_emissor_de_luz">Wikipedia</a>.
          Acesso em: 16 ago. 2020. <a href="https://creativecommons.org/licenses/by-sa/2.5/br/"> CreativeCommons</a>, não foi sujeito a alterações.
        </p>
        <div id="C" className='column'>
          <br /> <br /> <br /> <br /> <br /> <br />
          <Cores />
        </div>
      </div>
    </div>
  );
}

export default App;
